(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-collection-carousel';
  var TRACK_SELECTOR = '.oddit-section-collection-carousel__track';
  var CARD_SELECTOR = '.oddit-section-collection-carousel__card';
  var DOT_SELECTOR = '.oddit-section-collection-carousel__dot';
  var DOT_ACTIVE_CLASS = 'oddit-section-collection-carousel__dot--active';

  var sectionState = new Map();
  var sectionCounter = 0;

  function isMobileLayout(section) {
    // Match the CSS breakpoint at which the track switches from scroller to grid.
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getActiveIndex(track, cards) {
    var trackRect = track.getBoundingClientRect();
    var trackCenter = trackRect.left + trackRect.width / 2;
    var closestIndex = 0;
    var closestDistance = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var rect = cards[i].getBoundingClientRect();
      var cardCenter = rect.left + rect.width / 2;
      var distance = Math.abs(cardCenter - trackCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    }
    return closestIndex;
  }

  function updateDots(state, activeIndex) {
    for (var i = 0; i < state.dots.length; i++) {
      var isActive = i === activeIndex;
      state.dots[i].classList.toggle(DOT_ACTIVE_CLASS, isActive);
      state.dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
    }
  }

  function scrollToCard(track, card) {
    var trackRect = track.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var currentScroll = track.scrollLeft;
    // Delta needed so the card's left edge aligns to the track's left edge
    // (which itself sits at the scroll-padding-left gutter).
    var delta = cardRect.left - trackRect.left;
    track.scrollTo({
      left: currentScroll + delta,
      behavior: 'smooth'
    });
  }

  function handleScroll(state) {
    if (!isMobileLayout(state.section)) return;
    var activeIndex = getActiveIndex(state.track, state.cards);
    if (activeIndex !== state.activeIndex) {
      state.activeIndex = activeIndex;
      updateDots(state, activeIndex);
    }
  }

  function handleDotClick(state, index) {
    var card = state.cards[index];
    if (!card) return;
    state.activeIndex = index;
    updateDots(state, index);
    scrollToCard(state.track, card);
  }

  function initSection(section) {
    if (!section || sectionState.has(section)) return;

    var track = section.querySelector(TRACK_SELECTOR);
    if (!track) return;

    var cards = Array.prototype.slice.call(section.querySelectorAll(CARD_SELECTOR));
    var dots = Array.prototype.slice.call(section.querySelectorAll(DOT_SELECTOR));
    if (cards.length === 0) return;

    sectionCounter += 1;
    var uid = section.id || 'oddit-cc-' + sectionCounter;

    var state = {
      section: section,
      track: track,
      cards: cards,
      dots: dots,
      activeIndex: 0,
      uid: uid,
      onScroll: null,
      dotHandlers: []
    };

    state.onScroll = function () {
      handleScroll(state);
    };
    track.addEventListener('scroll', state.onScroll, { passive: true });

    for (var i = 0; i < dots.length; i++) {
      (function (index) {
        var handler = function (event) {
          event.preventDefault();
          handleDotClick(state, index);
        };
        state.dotHandlers.push({ dot: dots[index], handler: handler });
        dots[index].addEventListener('click', handler);
      })(i);
    }

    // Sync dots initially in case the browser restored scroll position.
    var initialIndex = getActiveIndex(track, cards);
    state.activeIndex = initialIndex;
    updateDots(state, initialIndex);

    sectionState.set(section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.onScroll) {
      state.track.removeEventListener('scroll', state.onScroll);
    }
    for (var i = 0; i < state.dotHandlers.length; i++) {
      var entry = state.dotHandlers[i];
      entry.dot.removeEventListener('click', entry.handler);
    }
    sectionState.delete(section);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();